<template>
  <v-col cols="12" xl="6" lg="4" md="4" sm="12" class="px-2 my-2" style="flex-wrap: nowrap">
    <v-card :loading="loading" style="height: inherit; padding: 4px">
      <v-list-item @click="handleSelectionClick" :disabled="disabled" :class="selected ? 'selected' : ''">
        <!-- image of the hall -->
        <slot name="avatar">
          <v-list-item-avatar size="64px">
            <slot name="avatar">
              <v-img height="100%" :src="previewImage" />
            </slot>
          </v-list-item-avatar>
        </slot>

        <v-list-item-content>
          <!-- title of the course -->
          <v-list-item-title>
            <v-row no-gutters style="align-items: center; flex-wrap: wrap; height: 64px;">
              <v-col cols="auto" style="vertical-align: middle">
                <p class="ma-0">
                  {{ course.CourseTitle }}
                </p>
              </v-col>
              <v-col cols="auto" class="ml-1" v-if="course.booked">
                <Tag :tagCount="1" :tagInfo="tagBooked" />
              </v-col>
              <v-col cols="auto" class="ml-1" v-if="course.payed">
                <Tag :tagCount="1" :tagInfo="tagPayed" />
              </v-col>
              <v-col cols="auto" class="ml-1" v-if="course.reserved">
                <Tag :tagCount="1" :tagInfo="tagReserved" />
              </v-col>
            </v-row>
          </v-list-item-title>

          <!-- info about the course -->
          <v-list-item-subtitle class="my-2" style="height: 120px">
            <!-- availabilty -->
            <div class="listitem-info-container">
              <div class="info-icon"><v-icon>mdi-calendar-range</v-icon></div>
              <div class="info-content" v-html="getFancyDatestring(course.CourseStartDate, course.CourseEndDate)" />
            </div>

            <!-- price -->
            <div class="listitem-info-container">
              <div class="info-icon"><v-icon>mdi-currency-eur</v-icon></div>
              <div class="info-content">{{ $n(course.RegularPrice, "currency", "de-DE") }}</div>
            </div>

            <!-- participants -->
            <div class="listitem-info-container">
              <div class="info-icon"><v-icon>mdi-account-multiple</v-icon></div>
              <div class="info-content">{{ courseParticipants }}</div>
            </div>

            <!-- designation -->
            <div class="listitem-info-container" v-if="!isNoWs(course.CourseDesignation)">
              <div class="info-icon"><v-icon>mdi-text</v-icon></div>
              <div class="info-content">{{ stripHtml(course.CourseDesignation) }}</div>
            </div>

            <!-- club internal course -->
            <div class="listitem-info-container" v-if="course.IsCourseClubOnly">
              <div class="info-icon"><v-icon>mdi-lock</v-icon></div>
              <div class="info-content">{{ $t("overview.preview_info_clubInternal") }}</div>
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- tags -->
      <v-row no-gutters class="mt-1 px-4">
        <v-slide-group show-arrows>
          <Tag v-for="(tag, index) of course.tags" :tagCount="course.tags.length" :key="'tag_coursePrev' + course.CourseId + '_' + index" :tagInfo="tag" />
        </v-slide-group>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
// vuex
import {mapGetters} from "vuex";
import {GET_SESSIONDATA} from "@/store/storeMutator.js";

// mixins
import HelpersMixin from "@/mixins/helpers.js";
import TagsMixin from "@/mixins/tags.js";

// components
import Tag from "@/components/controls/Tag.vue";

// assets
import placeholderImg from '@/assets/img/placeholder.jpg';

export default {
  name: "CoursePreviewItem",

  props: {
    courseId: String,
    selected: Boolean,
    disabled: Boolean,
    loading: Boolean,
  },

  emits: ["onSelect"],

  mixins: [HelpersMixin, TagsMixin],

  components: {
    Tag,
  },

  methods: {
    handleSelectionClick() {
      this.$emit("onSelect", this.course);
    },
  },

  computed: {
    ...mapGetters({SessionData: GET_SESSIONDATA}),

    course: {
      get() {
        return this.SessionData.club.courses.filter((course) => course.CourseId == this.courseId)[0];
      },
      set(val) {
        throw "you cant just set the course, update via mutators";
      },
    },

    /** returns an string for displaying the course participants - depening on data */
    courseParticipants() {
      var minMembers = this.course.MinMemberNumber;
      var maxMembers = this.course.MaxMemberNumber;
      var currentMembers = this.course.MemberNumber;

      var participantLoc = this.$t("overview.preview_info_participants");
      var minLoc = this.$t("common.label_min");

      if (minMembers !== 0 && maxMembers !== 0) {
        return `${currentMembers} ${participantLoc} / ${maxMembers} (${minLoc} ${minMembers})`;
      }

      if (minMembers === 0 && maxMembers !== 0) {
        return `${currentMembers} ${participantLoc} / ${maxMembers}`;
      }

      if (minMembers === 0 && maxMembers === 0) {
        return `${currentMembers} ${participantLoc}`;
      }
      return "noooow.... you got a strange course here...";
    },

    /** returns the image for the current preview, if available (otherwise placeholder image) */
    previewImage() {
      if (!this.isNoWs(this.course.CourseImage)) {
        return this.base64ImgPrefix + this.course.CourseImage;
      } else {
        return placeholderImg;
      }
    },
  },
};
</script>

<style scoped>
.listitem-info-container {
  /* behavior */
  display: flex;
  /* flex properties */
  gap: 8px;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

.info-icon {
  flex: 0 0 max-content;
}

.info-content {
  /* behavior */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  /* flex properties */
  flex: 1 1 auto;
}
</style>
